import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import industries from "config/industries";

export default function IndustryCarousel() {
  return (
    <MKBox py={10} px={3} textAlign="center">
      {/* Section Heading */}
      <MKTypography variant="h3" fontWeight="bold" mb={6}>
        Industries We Cover
      </MKTypography>

      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={24}
        slidesPerView={1}
        autoplay={{ delay: 3500 }}
        pagination={{ clickable: true }}
        style={{ paddingBottom: "40px" }} // ⬅️ fixes dot-overlap issue
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {industries.map((industry, index) => (
          <SwiperSlide key={index}>
            <MKBox
              position="relative"
              borderRadius="xl"
              overflow="hidden"
              boxShadow="0 8px 24px rgba(0,0,0,0.08)"
              sx={{
                transition: "transform 0.3s ease",
                "&:hover": { transform: "translateY(-6px)" },
              }}
            >
              {/* Industry Image */}
              <MKBox
                component="img"
                src={industry.icon}
                alt={industry.name}
                sx={{
                  width: "100%",
                  height: 220,
                  objectFit: "cover",
                }}
              />

              {/* Gradient Overlay */}
              <MKBox
                position="absolute"
                bottom={0}
                width="100%"
                height="100%"
                sx={{
                  background: "linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0))",
                }}
              />

              {/* Text on top of gradient */}
              <MKBox
                position="absolute"
                bottom={0}
                width="100%"
                py={1.5}
                px={2}
                display="flex"
                justifyContent="center"
                zIndex={1}
              >
                <MKTypography variant="h6" color="white" fontWeight="medium">
                  {industry.name}
                </MKTypography>
              </MKBox>
            </MKBox>
          </SwiperSlide>
        ))}
      </Swiper>
    </MKBox>
  );
}
